import React, { useState } from 'react';
import { Controller, UseFormResetField, UseFormTrigger, UseFormSetValue, Control, UseFormWatch, FieldErrors, UseFormRegister } from 'react-hook-form';
import ReactInputMask from 'react-input-mask';
import { CartFieldWrp } from './components/CartFieldWrp';
import { CartSelect } from './components/CartSelect';
import { CartInput } from './components/CartInput';
import { TextareaField } from '../../../shared/ui/textarea-field';
import { Contact, Employee, FetchStatusType } from '../../../types/interfaces';
import { useMe } from '../../../pages/Area/Area';
import { useEmployees } from '@entities/employee/lib/useEmployees';
import { Button } from '../../../shared/ui/button';

interface ICartStepContactDetails {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setValue: UseFormSetValue<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  watch: UseFormWatch<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cartErrors: FieldErrors<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: UseFormRegister<any>;
  setStepOnDelivery: () => void;
  setYourCartStep: () => void;
  isValid: boolean;
  status: FetchStatusType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reset: UseFormResetField<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trigger: UseFormTrigger<any>;
}

interface ISelect {
  label: string;
  value: string | number;
}
export function CartStepContactDetails({
  setValue,
  control,
  watch,
  cartErrors,
  register,
  setStepOnDelivery,
  setYourCartStep,
  isValid,
  status,
  trigger,
}: ICartStepContactDetails) {
  const { me } = useMe();
  const employees = useEmployees();
  const [contactChooseType, setContactChooseType] = useState<string>('select');
  function selectLegalEntityAndAddresses(item: ISelect) {
    setValue('legal_entity', {
      label: item.label,
      value: item.value,
    });
  }

  function getPersonInfo(person: Contact | Employee) {
    const isContact = 'name' in person;
    if (isContact) {
      const fullName = `${person?.surname} ${person?.name} ${person?.patronymic}`;
      const phone = person.personal_phone;
      const mail = person.mail;
      return { fullName, phone, mail };
    }

    const fullName = `${person?.last_name} ${person?.first_name} ${person?.patronymic}`;
    const phone = person.mobile_phone;
    const mail = person.email;
    return { fullName, phone, mail };
  }

  function isContact(person: any) {
    if ('value' in person) {
      return typeof person.value === 'string';
    }
    return typeof person.id === 'string';
  }
  function getOptionsForContact() {
    const persons = [...employees, ...(me.company?.contacts || [])] satisfies (
      | Contact
      | Employee
    )[];
    return persons.map((person) => {
      const { fullName } = getPersonInfo(person);
      return {
        label: fullName,
        value: person.id,
      };
    });
  }
  function selectContact(person: ISelect) {
    const fullPerson = isContact(person)
      ? me.company?.contacts.find((contact) => contact.id === person.value)
      : employees.find((employee) => employee.id === person.value);
    if (!fullPerson) {
      return;
    }
    const { fullName, mail, phone } = getPersonInfo(fullPerson);
    setValue('contact_full_name', fullName);
    setValue('contact_phone', phone);
    setValue('contact_email', mail);
    trigger();
  }

  const contactSelectError =
    cartErrors?.contact_full_name || cartErrors?.contact_phone
      ? 'Выберите контакт из списка или заполните данные вручную'
      : '';

  return (
    <>
      <div className='h-full py-6  flex gap-6'>
        <div className='flex-1'>
          <CartSelect
            onChange={selectLegalEntityAndAddresses}
            value={watch('legal_entity')}
            options={
              me?.company?.legal_entities?.map((i) => ({
                label: i.name,
                value: i.id,
              })) || []
            }
            label="Юридическое лицо"
            placeholder="Выберите юридическое лицо*"
          />
          <div className="gap-4 pt-2">
            <p className='text-sm font-medium text-gray-600'>Выбор контактного лица</p>
            <div className="flex gap-4 py-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="contactEnterType"
                id="select"
                value="select"
                onChange={(e) => setContactChooseType(e.target.value)}
                checked={contactChooseType === 'select'}
                 className="w-4 h-4 accent-red-600 cursor-pointer"
              />
              <span className="text-sm font-medium text-gray-700">
                Выбрать из существующих
              </span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="contactEnterType"
                id="enter"
                value="enter"
                onChange={(e) => {
                  setContactChooseType(e.target.value);
                }}
                checked={contactChooseType === 'enter'}
                 className="w-4 h-4 accent-red-600 cursor-pointer"
              />
              <span className="text-sm font-medium text-gray-700">
                Ввести вручную
              </span>
            </label>
            </div>

          </div>
          {contactChooseType === 'select' && (
            <CartFieldWrp title="Контактное лицо*" error={contactSelectError}>
              <CartSelect
                defaultValue={getOptionsForContact()?.[0]}
                value={{ label: watch('contact_full_name'), value: '' }}
                onChange={selectContact}
                options={getOptionsForContact() || []}
                placeholder="Выберите контакт"
              />
            </CartFieldWrp>
          )}

          {contactChooseType === 'enter' && (
            <>
              <CartFieldWrp>
                <CartInput
                  label="ФИО*"
                  inputName="contact_full_name"
                  id="contact_full_name"
                  register={register}
                  placeholder="Иванов Иван Иванович"
                  errors={cartErrors}
                />
              </CartFieldWrp>
              <CartFieldWrp>
              <Controller
                name="contact_phone"
                control={control}
                render={({ field }) => (
                  <CartInput
                    {...field}
                    as={ReactInputMask}
                    mask={'+7 (***) ***-**-**'}
                    id="contact_phone"
                    inputName="contact_phone"
                    label="Телефон*"
                    errors={cartErrors}
                    placeholder="8 (999) 999-99-99"
                    register={register}
                  />
                )}
              />
              </CartFieldWrp>
              <CartInput
                label="Электронная почта"
                inputName="contact_email"
                id="contact_email"
                register={register}
                errors={cartErrors}
                placeholder="3nUeh@example.com"
              />
            </>
          )}
        </div>
        <div className='flex-1'>
          <TextareaField
            className='h-[calc(100%-3rem)]'
            currentVal={watch('comment') as string | undefined}
            maxLength={2000}
            id="comment"
            name="comment"
            label="Комментарий к заказу"
            errors={cartErrors}
            register={register}
            placeholder="Ваш комментарий"
          />
        </div>
      </div>
      <div className="w-full flex justify-end">
        <div className="flex  gap-3 mt-6 w-[calc(100%-20rem)] items-center">
          <Button
            onClick={(e: React.MouseEvent): null | void => {
              e.preventDefault();
              e.stopPropagation();
              setYourCartStep();
            }}
            variant='light'
            type="button"
          >
            Назад
          </Button>
          <Button
            type="submit"
            variant='light'
          >
            Оформить без доставки
          </Button>
          <Button
            onClick={(e: React.MouseEvent): null | void => {
              trigger();
              if (isValid) {
                e.preventDefault();
                e.stopPropagation();
                setStepOnDelivery();
              }
            }}
            type="button"
          >
            Продолжить
          </Button>
        </div>
      </div>


    </>
  );
}
